export default {
  title: 'Crear enlace de incorporación',
  steps: {
    select_gateway: 'Seleccionar pasarela',
    copy_link: 'Copiar enlace',
  },
  select_gateway: {
    description: 'Elige la pasarela de pago para la que deseas generar un enlace de incorporación de larga duración.',
  },
  link: {
    proxy_url_label: 'URL de incorporación',
    expires_label: 'Vence',
    copy_button: 'Copiar URL',
    copied: '¡Copiado!',
    description:
      'Comparte esta URL con el comerciante. Redirige a la página de incorporación de la pasarela y es válida hasta la fecha de vencimiento.',
  },
  buttons: {
    next: 'Siguiente',
    back: 'Atrás',
    done: 'Listo',
  },
  toasts: {
    create_success: 'Enlace de incorporación creado correctamente.',
    create_failed: 'Error al crear el enlace de incorporación.',
  },
};
